import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ModalInjectorService } from '../../services/modal-injector.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-observacion-modal',
  templateUrl: './observacion-modal.component.html',
  styleUrls: ['./observacion-modal.component.css'],
})
export class ObservacionModalComponent implements OnInit {
  Observaciones: FormGroup;
  aviso: string;
  correos: any[] = [];
  correo: string;
  addEmail: boolean;
  emailsLimit: number;

  constructor(
    public dialogRef: MatDialogRef<ObservacionModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    private router: Router,
    private checkData: ModalInjectorService
  ) {
    this.crearFormulario();
  }

  ngOnInit(): void {
    console.log('DATA', this.data);
    this.inicio();
    this.emailsLimit=1;
    this.correos.length.toFixed(this.emailsLimit);
    this.addEmail=true;
    
  }

  crearFormulario(): any {
    this.Observaciones = this.fb.group({
      obs: '',
      mandato: false,
      poder: false,
      contrato: false,
      rol: '',
      chekeado: true,
      comunicarA: [
        [],
        [
          Validators.minLength(5),
          Validators.pattern(
            /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          ),
        ],
      ],
    });
  }

  Guardar(): any {
    this.dialogRef.close(this.Observaciones.value);
  }

  addToCorreoToList(): void {
    if (
      this.correo &&
      !this.comprobarCorreosLength() &&
      this.validateEmail(this.correo)
    ) {
      this.correos.push(this.correo);
      this.Observaciones.get('comunicarA').setValue(this.correos);
      this.correo = '';
      if(this.comprobarCorreosLength())
        {
          this.addEmail=false;
        }
    } else if (
      this.comprobarCorreosLength() &&
      this.validateEmail(this.correo)
    ) {
      this.correo = '';
      Swal.fire('', 'Sólo se permiten '+this.emailsLimit+ ' correos adicionales', 'error');
    } else {
      Swal.fire('', 'El correo no es válido o está vacío', 'error');
    }
  }

  validateEmail(email: string): boolean {
    const re =
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  }

  comprobarCorreosLength(): boolean {
    return this.correos.length >= this.emailsLimit;
  }

  removeFromList(i: number): void {
    this.correos.splice(i, 1);
    this.Observaciones.get('comunicarA').setValue(this.correos);
    this.addEmail=true;
  }

  inicio(): void {
    document.getElementById('poder').hidden = true;
    document.getElementById('mandato').hidden = true;
    document.getElementById('texto').hidden = true;
    document.getElementById('contrato').hidden = true;
    if (this.data.tipo.includes('MATRICULACION')) {
      console.log(this.data.tipo);
      const checkData = this.checkData.checkDataMatriculacion(this.data);
      // TODO: CHECKSMSMCLIENTECOMPRADOR
      // false->DESACTIVAR LOS DOS CHECKS Y PONER DATOS INSUFICIENTE PARA PODER REALIZAR LA FIRMA
      // rol->ERROR
      if (checkData === false) {
        this.errorData();
      }
      // true
      if (checkData === true) {
        document.getElementById('texto').hidden = false;
        if (this.data.sexo === 'HOMBRE' || this.data.sexo === 'MUJER') {
          document.getElementById('mandato').hidden = false;
          this.Observaciones.controls.mandato.setValue(true);
        }
        if (this.data.sexo === 'EMPRESA') {
          document.getElementById('mandato').hidden = false;
          document.getElementById('poder').hidden = false;
          this.Observaciones.controls.mandato.setValue(true);
          this.Observaciones.controls.poder.setValue(true);
        }
        this.Observaciones.controls.rol.setValue('VENDEDOR');
      }
    }

    if (
      this.data.tipo === 'CAMBIO DE PROPIEDAD' ||
      this.data.tipo === 'DOBLE TRANSFERENCIA'
    ) {
      console.log(this.data.tipo);
      const comprador = this.checkData.checkSMSClienteComprador(this.data);
      const vendedor = this.checkData.checkSMSClienteVendedor(this.data);
      console.log('Comprador', comprador);
      console.log('Vendedor', vendedor);
      if (sessionStorage.getItem('tipoCliente') === '1') {
        // TODO: CHECKSMSMCLIENTECOMPRADOR
        // false->DESACTIVAR LOS DOS CHECKS Y PONER DATOS INSUFICIENTE PARA PODER REALIZAR LA FIRMA
        // rol->ERROR
        if (comprador === false) {
          this.errorData();
        }
        // true
        if (comprador === true) {
          document.getElementById('contrato').hidden = false;
          this.Observaciones.controls.contrato.setValue(true);
          document.getElementById('texto').hidden = false;
          if (this.data.sexo === 'HOMBRE' || this.data.sexo === 'MUJER') {
            document.getElementById('mandato').hidden = false;
            this.Observaciones.controls.mandato.setValue(true);
          }
          if (this.data.sexo === 'EMPRESA') {
            document.getElementById('mandato').hidden = false;
            document.getElementById('poder').hidden = false;
            this.Observaciones.controls.mandato.setValue(true);
            this.Observaciones.controls.poder.setValue(true);
          }
          this.Observaciones.controls.rol.setValue('VENDEDOR');
        }
      }

      if (sessionStorage.getItem('tipoCliente') === '2') {
        // TODO:CHECKSMSMCLIENTEVENDEDOR
        // false->DESACTIVAR LOS DOS CHECKS Y PONER DATOS INSUFICIENTE PARA PODER REALIZAR LA FIRMA
        // rol->ERROR
        if (vendedor === false) {
          this.errorData();
        }
        // true
        if (vendedor === true) {
          document.getElementById('contrato').hidden = false;
          this.Observaciones.controls.contrato.setValue(true);
          document.getElementById('texto').hidden = false;
          if (
            this.data.sexoVendedor === 'HOMBRE' ||
            this.data.sexoVendedor === 'MUJER'
          ) {
            document.getElementById('mandato').hidden = false;
            this.Observaciones.controls.mandato.setValue(true);
          }
          if (this.data.sexo === 'EMPRESA') {
            document.getElementById('mandato').hidden = false;
            document.getElementById('poder').hidden = false;
            this.Observaciones.controls.mandato.setValue(true);
            this.Observaciones.controls.poder.setValue(true);
          }
          this.Observaciones.controls.rol.setValue('COMPRADOR');
        }
      }

      if (
        sessionStorage.getItem('tipoCliente') === '3' ||
        sessionStorage.getItem('tipoCliente') === 'null'
      ) {
        // TODO: CHECKSMS DE AMBOS
        // false->DESACTIVAR LOS DOS CHECKS Y PONER DATOS INSUFICIENTE PARA PODER REALIZAR LA FIRMA
        // rol->ERROR
        if (vendedor === false || comprador === false) {
          this.errorData();
        }
        if (vendedor === true && comprador === true) {
          document.getElementById('contrato').hidden = false;
          this.Observaciones.controls.contrato.setValue(true);
          document.getElementById('texto').hidden = false;
          if (
            (this.data.sexoVendedor === 'HOMBRE' &&
              this.data.sexo === 'MUJER') ||
            (this.data.sexo === 'HOMBRE' && this.data.sexoVendedor === 'MUJER')
          ) {
            document.getElementById('mandato').hidden = false;
            this.Observaciones.controls.mandato.setValue(true);
          } else {
            this.Observaciones.controls.mandato.setValue(true);
            this.Observaciones.controls.poder.setValue(true);
            document.getElementById('poder').hidden = false;
            document.getElementById('mandato').hidden = false;
          }
        }
        this.Observaciones.controls.rol.setValue('INTERMEDIARIO');
      }
    }
    /*
      if (this.data.colaborador !== 'CUIMO'){
        document.getElementById('contrato').hidden = true;
      }
      */
  }

  onNoClick(): void {
    this.Observaciones.controls.chekeado.setValue(false);
    this.dialogRef.close(this.Observaciones.value);
  }

  errorData(): void {
    this.aviso =
      'Debido a falta de datos no se enviará la firma de documentos,' +
      ' si desea el envio de firma, por favor presione cancelar y complete los campos referentes a cliente.';
  }
}
